module.exports = __webpack_public_path__ + "static/media/Wildcat Territory_4c.ea3fe07b.svg";